import ActiveRecord from './active_record/base'

class Admin extends ActiveRecord {
	static tableName = 'admins'
	static sort = 'name'
}

export default Admin
